export const categories = [
    { id: 1, type: "Love" },
    { id: 2, type: "Sad" },
    { id: 3, type: "Motivation" },
    { id: 4, type: "Emotional" },
    { id: 5, type: "Nature" }
];